import styles from './InstructionLessonRun.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';

type Props = {
  open: boolean;
  onClose: () => void;
  onStartLesson: () => void;
  openMaterial: () => void;
  title?: string;
  subTitle?: React.ReactNode;
  mainContent?: React.ReactNode;
  lastContent?: string;
  downloadLabel?: string;
  startLabel?: string;
};

function InstructionLessonRun(props: Props) {
  const { open, title, subTitle, mainContent, lastContent, downloadLabel, startLabel, onClose, onStartLesson, openMaterial } = props;

  return (
    <Modal global={false} open={open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <div className={styles.header}>
          <div className={styles.title}>{title ? title : 'Important Requirement'}</div>
        </div>
        <div className={styles.content}>
          <div className={styles.normalText}>{subTitle}</div>
          <div className={styles.normalText}>{mainContent ? mainContent : 'Please ensure you have downloaded it prior to beginning the lesson, as it contains important information and discussion points.'}</div>
          <div className={styles.normalText}>{lastContent ? lastContent : 'The Teacher Key can be found in the Lesson Materials section.'}</div>
          <div className={styles.action}>
            <Button size="small" className={styles.downButton} onClick={openMaterial} label={downloadLabel ? downloadLabel : 'Download Key'}/>
            <Button size="small" className={styles.startButton} onClick={onStartLesson} label={startLabel ? startLabel : 'Start Lesson'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default InstructionLessonRun;
